import styled from 'styled-components';

export const NoticeBox = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1.5rem;
  max-width: max-content;
  background-color: #ceedf3;
  border: 1px solid #525a653d;
  color: #000000;
  border-radius: 0.25rem;
  padding: 1rem;
  margin: 1rem 0.75rem;
`;

export const NoticeHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.75rem;
  margin: 0;
  svg {
    color: #056274;
  }
`;

export const NoticeBody = styled.p`
  margin: 0;
  font-size: 0.75rem;
  line-height: 1rem;
  margin-left: 0.5rem;
`;

export const NoticeList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;
